var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.49992 1.66663H15.4999C16.4166 1.66663 17.1666 2.33329 17.1666 3.14811V4.77774C17.1666 5.37033 16.7499 6.11107 16.3333 6.48144L12.7499 9.29626C12.2499 9.66663 11.9166 10.4074 11.9166 11V14.1851C11.9166 14.6296 11.5833 15.2222 11.1666 15.4444L9.99992 16.1111C8.91659 16.7037 7.41658 16.037 7.41658 14.8518V10.9259C7.41658 10.4074 7.08325 9.7407 6.74992 9.37033L3.58325 6.40737C3.16659 6.037 2.83325 5.37033 2.83325 4.92589V3.22218C2.83325 2.33329 3.58325 1.66663 4.49992 1.66663Z",
    stroke: "#0A5EF3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.10833 1.66663L5 7.51848",
    stroke: "#0A5EF3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d2e30f7cbe0aa44e70b7eb39d59fc198.svg";
export { ForwardRef as ReactComponent };